/**
 * Converting a string to the format +7 (000) 000-00-00
 * @param {string} phone Phone number
 * @param mask Formatting mask
 * @returns {string} Formatted string
 */
export const formatPhoneNumber = (phone: string, mask: string): string => {
    const literalPattern = /[0\*]/;
    const numberPattern = /[0-9]/;
    let newValue = "";
    let valueIndex = 0;
    let maskIndex = 0;

    while (maskIndex < mask.length) {
      if (maskIndex >= phone.length) {
        break;
      }
      if (
        mask[maskIndex] === "0" &&
        phone[valueIndex].match(numberPattern) === null
      ) {
        break;
      }
      while (mask[maskIndex].match(literalPattern) === null) {
        if (phone[valueIndex] === mask[maskIndex]) {
          break;
        }
        newValue += mask[maskIndex++];
      }
      newValue += phone[valueIndex++];
      maskIndex++;
    }

    return newValue;
  };